import { FC } from 'react';
import { Newsletter } from '../../../shared/components/Newsletter';
import { SectionIntro } from '../../../shared/styles/TextFields';

import { Button, VText } from '@vake/ui-kit';
import { Link } from 'react-router-dom';

const about = [
    {
        icon: 'images/icons/Multispectral.png',
        heading: 'Multispectral',
        description:
            'We deliver automated vessel detections in multispectral satellite imagery. These images, processed by our algorithm, exploit information throughout the light spectrum, uncovering information no current system can.',
    },
    {
        icon: 'images/icons/Specialized.png',
        heading: 'Specialized',
        description:
            'As opposed to other satellite data analytics solutions, we’re deeply specialised in Maritime Domain analysis. Our solution is proven to efficiently, affordably and automatically detect vessels in any area of interest.',
    },
    {
        icon: 'images/icons/Flexible.png',
        heading: 'Flexible',
        description:
            'We are experts in geospatial data. This makes us able to unlock the real insights of data fusion, and flexible to use the data sources that fit your use case and budget. Our current source results in a price at the fraction of other systems.',
    },
];

const How: FC = () => (
    <>
        <Newsletter
            bottom
            header="See how maritime satellite data impacts business insights and intelligence"
            description="VAKE is continuously improving maritime insights services in close collaboration with governments, offshore asset owners and shipping companies. Sign up to learn more about how AI-boosted satellite data can highlight what is happening at sea, and what this means for your business and use cases.  "
        />
        <div className="flex flex-col w-[1255px] max-w-[calc(100%-50px)] m-auto">
            <VText variant="H1">Technology</VText>
            <SectionIntro>
                <VText>
                    We use our cutting-edge machine learning algorithms to detect ships in satellites images, which
                    provides the focal points needed for your maritime operations.
                </VText>
            </SectionIntro>
            <div className="flex justify-between gap-4">
                {about.map((item, i) => {
                    const aboutKey = `about_${i}`;
                    return (
                        <div className="flex flex-col justify-between" key={aboutKey}>
                            <div className="justify-start h-[42px]">
                                <img src={item.icon} alt={`${item.heading}`} />
                            </div>
                            <VText variant="H2">{item.heading}</VText>
                            <VText>{item.description}</VText>
                        </div>
                    );
                })}
            </div>
            <div className="flex justify-center gap-4 p-16 m-auto">
                <Link to="/report-builder">
                    <Button
                        text="Try a free report"
                        onClick={() => {
                            window.sa_event(() => 'req_det_open_form_about_on_' + window.document.location.search);
                        }}
                    ></Button>
                </Link>
            </div>
        </div>
    </>
);

export default How;
